<template>
    <div>
        <monthlytax-form v-if="this.id == 1"
            v-bind:parentObject = "{
                data: this.item,
                id: this.id,
                errMsg: this.errMsg,
            }"
        />
        <div v-if="isErr">
            <app-error 
                v-bind:parentError = "{
                    data: this.errMsg,
                    isErr: this.isErr
                }"
                v-on:closeError="isErr = $event"
            />
        </div>   
    </div>
</template>

<script>
import MonthlyTaxForm from '../../../components/payroll/mmmonthlytaxexport/MonthlyTaxPaye.vue';
import ErrorDialog from '../../../components/common/ErrorDialog';

export default {
    components: {
        'monthlytax-form': MonthlyTaxForm,
        'app-error': ErrorDialog
    },

    data() {
        return{
            pageTitle: this.$t('alltax.monthlytax'),
            item: this.$route.params.item,
            id: this.$route.params.id,
            
            errMsg: '',
            isErr: false,
            editMode: false 
        }
    },

}

</script>